// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote_quote__Kb44z","content":"quote_content__0xtOF","img":"quote_img__hZ_7p"};